// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper--RWirs","small":"small--3zrow"};